import _ from 'lodash'

export const getMappingCount = (obj) => {
  const values = _.values(obj || {})
  let resultCount = -1

  _.each(values, function (row) {
    if (_.isArray(row)) {
      resultCount = _.max([resultCount, row.length])
    } else if (_.isObject(row)) {
      let isList = true
      let keys = Object.keys(row)
      let maxItem = -1
      _.each(keys, function (key) {
        key = parseInt(key)
        if (isNaN(key)) {
          isList = false
        } else {
          key = key + 1
          if (maxItem < key) {
            maxItem = key
          }
        }
      })
      if (isList && maxItem > -1) {
        resultCount = _.max([resultCount, maxItem])
      } else {
        let childCount = getMappingCount(row)
        resultCount = _.max([childCount, resultCount])
      }
    } else if (resultCount === -1) {
      if (['string', 'number', 'boolean', 'bigint'].includes(typeof row)) {
        resultCount = 1
      }
    }
  })

  return Math.max(0, resultCount)
}

export const getHiddenCount = (obj, totalCount) => {
  const flags = obj?.isInvisible
  if (!flags) return 0

  let hidden = 0
  _.each(flags, (val, key) => {
    if (!val) {
      return
    }
    if (typeof totalCount === 'number') {
      const n = Number(key)
      if (!Number.isInteger(n) || n < 0 || n >= totalCount) {
        return
      }
    }
    hidden++
  })
  return hidden
}

export const getVisibleCount = (obj) => {
  const totalCount = getMappingCount(obj)
  const hiddenCount = getHiddenCount(obj, totalCount)
  const visibleCount = Math.max(0, totalCount - hiddenCount)
  return { totalCount, visibleCount }
}

export const checkIfAllItemsHidden = (visibleItems, totalItems) => {
  return totalItems > 0 && visibleItems === 0
}
